import React, { Component, Suspense, lazy } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Route, Switch, useHistory } from "react-router-dom";

// Layouts
import routes from "./routes";
import PublicLayout from "./shared/layout/PublicLayout";
import AuthLayout from "./shared/layout/AuthLayout";

// Public Pages
import Signup from "pages/signup/SignupContainer";
import VerifyEmail from "pages/verifyEmail/VerifyEmailContainer";
import Login from "pages/login/LoginContainer";
import Reset from "pages/resetPassword/ResetPasswordContainer";
import Reset2 from "components/widgets/forms/passwordReset/PasswordResetContainer";
import VerifyReset from "pages/verifyResetToken/VerifyResetTokenContainer";
import Home from "pages/home/Home";
import Error from "pages/errors/404";
import ForgotPassword from "pages/login/ForgotPassword";
import VerifyCode from "pages/login/VerifyCode";
import VerifyOtp from "pages/login/VerifyOtp";
import ResetPassword from "pages/login/ResetPassword";
import Ptnc from "pages/tnc/Ptnc";

// Authenticated Pages
import Dashboard from "pages/dashboard/DashboardContainer";
import Credentials from "pages/credentials/CredentialsContainer";
import Appointments from "pages/appointments/AppointmentContainer";
import Reports_Config from "pages/reportsConfig/Reports_Config";
import View_Report_Group from "pages/viewReportGroup/View_Report_Group";
import Departments from "pages/departments/DepartmentsContainer";
import Users from "pages/users/UsersContainer";
import UserGroups from "pages/userGroups/UserGroupContainer";
import ChatUsers from "pages/chatUsers/Chat_Users";
import SecurityContext from "pages/securityContext/SecurityContextContainer";
import View_Security_Context from "pages/viewSecurityContext/ViewSecurityContextContainer";
import View_Reports from "pages/viewReports/View_Reports";
import View_Users from "pages/viewUsers/ViewUsersContainer";
import View_Department from "pages/viewDepartment/ViewDepartmentContainer";
import ViewUser from "pages/viewUser/ViewUserContainer";
import View_User_Group from "pages/viewUserGroup/ViewUserGroupContainer";
import View_Chat_User from "pages/viewChatUser/View_Chat_User";
import Commissions from "pages/commissions/Commissions";
import TnC from "pages/tnc/TnCContainer";
import Tenders from "pages/tenders/TendersContainer";
import Underwriters from "pages/underwriters/Underwriters";
import Claims from "pages/claims/ClaimsContainer";

import ViewRenewal from "pages/viewRenewal/View_Renewal";
import ViewRequests1 from "pages/viewRequests1/View_Request";

import Renewals from "pages/renewals/Renewals";
import Portfolio from "pages/portfolioManagement/Portfolio";
import SinglePolicy from "pages/portfolioManagement/SinglePolicy";

import Requests from "pages/requests/Requests";
import Profession from "pages/profession/ProfessionContainer";

import AssetDetails from "pages/assetDetails/Asset_Details";
import AssetDetails1 from "pages/assetDetails1/Asset_Details";

import Special_Considerations from "pages/Special_Consideration";
import ViewClaim from "pages/viewClaim/ViewClaimContainer";
import Profile from "pages/profile/Profile";

import ViewReports from "pages/viewReports/View_Reports";
import Roles from "pages/roles/RolesContainer";
import ViewRole from "pages/viewRole/ViewRoleContainer";
import Settlement from "pages/settlement/settlement/SettlementContainer";
import Channels from "pages/settlement/channel/ChannelContainer";
import SettlementConfig from "pages/settlement/config/ConfigContainer";
import ConfigDetails from "pages/settlement/config/ConfigDetails";
import SettlementDetails from "pages/settlement/settlement/SettlementDetails";
import ChannelDetails from "pages/settlement/channel/ChannelDetails";
import Reviews from "pages/reviews/ReviewsContainer";
import Chat from "pages/chat/ChatContainer";
import ChatGroup from "pages/chatGroups/ChatGroupContainer";

import Settlements from "pages/accountManagement/settlement/Settlements";
import SettlementConfigs from "pages/accountManagement/settlement/SettlementConfig";
import SettlementConfigDetails from "pages/accountManagement/settlement/SettlementConfigDetails";
import settlementRequests from "pages/accountManagement/settlement/settlementRequests";
import SettlementRequest from "pages/accountManagement/settlement/SettlementRequest";

import RM from "pages/relationshipManager/RMContainer";
import RMDetails from "pages/relationshipManager/RmDetails";
import SalesRep from "pages/salesRepresentative/SalesContainer";
import SalesDetails from "pages/salesRepresentative/SalesDetails";
import Leads from "pages/leads/LeadsContainer";
import LeadDetails from "pages/leads/LeadsDetails";
import ClaimsPending from "pages/claimsPendingApproval/ClaimsPendingContainer";
import ViewClaimPendingContainer from "pages/viewClaimPending/ViewClaimPendingContainer";

import OpenLeads from "pages/openLeads/OpenLeadsContainer";
import IncentivesContainer from "pages/incentives/IncentivesContainer";
import IncentiveDetails from "pages/incentives/IncentiveDetails";

// Quotations
import Quotations from "pages/quotations/QuotationsContainer";
import ClientQuotations from "pages/quotations/ClientQuotationsContainer";
import Quotations1 from "pages/quotation1/QuotationsContainer";
import ViewRequests from "pages/quotations/QuotationRequestDetails";
import QuotationRequests from "pages/quotations/QuotationRequestContainer";
import ViewQuotation from "pages/viewQuotation/ViewQuotationContainer";
import ViewQuotation1 from "pages/viewQuotation1/ViewQuotationContainer";
import View_Quotation from "pages/viewQuotation/View_Quotation";

// policy
import Policies from "pages/policies/PoliciesContainer";
import PolicyDetails from "pages/policies/PolicyDetails";

// account Management
import Wallet from "pages/accountManagement/WalletContainer";
import View_Wallet from "pages/accountManagement/WalletDetails";
import View_Commission from "pages/accountManagement/CommissionDetails";
//import CommissionEntries from "pages/accountManagement/CommissionEntries";
import Tax from "pages/accountManagement/TaxContainer";
import TaxDetails from "pages/accountManagement/TaxDetails";
import Fees from "pages/accountManagement/FeesContainer";
import FeeDetails from "pages/accountManagement/FeeDetails";

// domain
import Domains from "pages/domains/DomainsContainer";

// Scheme Management
import Schemes from "pages/schemeManagement/ListSchemes";
import SchemeDetails from "pages/schemeManagement/SchemeDetails";
import GroupSchemeDetails from "pages/schemeManagement/GroupSchemeDetails";
import UnderwriterDetails from "pages/schemeManagement/UnderwriterRates";
import GroupSchemeManagement from "pages/schemeManagement/ManageGroupScheme";

import NetworkDetector from "services/NetworkDetector";
import Fallback from "shared/errorBoundary/Fallback";
import SingleClientQuotation from "pages/quotations/SingleClientQuotation";
import Products from "pages/productManagement/Products";
import Setup from "pages/setup/Setup";
import Account from "pages/myAccount/Account";

import Benefits from "pages/setup/Benefits";
import Benefit from "pages/setup/Benefit";
import Dmvic from "pages/setup/Dmvic";


import Underwriter from "pages/myunderwriters/Underwriter";
import NewProduct from "pages/setup/NewProduct";
import EditProduct from "pages/setup/EditProduct";
import NewRate from "pages/setup/NewRate";
import ViewProduct from "pages/setup/ViewProduct";
import ProductList from "pages/setup/Products";
import View_Product_Underwriter from "./pages/underwriters/myunderwriterview";

// product config imports
import PolicyNumberConfig from "pages/productconfig/PolicyNumberConfig";
import motorcertificateConfigPage from "pages/productconfig/motorcertificateconfig";
import BenefitsSection from "pages/productconfig/productbenefitsconfig";
import ExcessLiabilityConfig from "pages/productconfig/ExcessLiabilityConfig";
import PremiumConfigPage from "pages/productconfig/PremiumPricingConfig";
import PaymentConfigPage from "pages/productconfig/paymentconfig";
import PolicyConfigPage from "pages/productconfig/policyconfig";
import AccountingConfigPage from "pages/productconfig/AccountingConfig";
import ProductDetailsPage from "pages/productconfig/ProductDetailsPage";
import Inventory from "pages/Inventory/inventory";
import Reports from "pages/Reports/Reports";
import Invoices from "pages/Reports/invoices";
import RenewalsReports from "pages/Reports/renewals";
import CommissionsReports from "pages/Reports/commisions";
import ProductRequirementsConfig from "pages/productconfig/ProductRequirementConfig";
import ProductTermsAndConditionsConfig from "pages/productconfig/ProductTermsConfig";
import ValuationProductConfig from "./pages/productconfig/ValuationProductConfig";
import ProductDocumentConfig from "./pages/productconfig/ProductDocumentConfig";
import CoverageDetailsConfig from "./pages/productconfig/CoverageDetailsConfig";
import LiabilityConfig from "./pages/productconfig/LiabilityConfig";

import CommissionsAccount from "pages/accountManagement/Commisions";
import CommissionDetailAccount from "pages/accountManagement/CommisionDetailsNew";
import DirectQuotation from "pages/directQuotation/DirectQuotation";
import ViewDirectQuotation from "pages/directQuotation/ViewDirectQuotation";
import ViewInvoice from "pages/Invoices/ViewInvoices";

import ClientHelpRequest from "pages/clientHelp/ClientHelpRequest";
import ViewClientHelpRequest from "pages/clientHelp/ViewClientHelpRequest";
import ViewUnderwriter from "pages/myunderwriters/viewUnderwriter"
import AccountManagement from "pages/accountManagement/Accounting/AccountingLandingPage";
import AccountingCommissions from "pages/accountManagement/Accounting/AccountingCommision";
import AccountingPolicies from "pages/accountManagement/Accounting/AccountingPolicies";
import AccountingInvoices from "pages/accountManagement/Accounting/AccountingInvoices";
import AccountTaxes from "pages/accountManagement/Accounting/AccountingTaxes";
import AccountingWallet from "pages/accountManagement/Accounting/AccountingWallet";

//modules
import Modules from "pages/modules/Modules";
import UnderwritingServices from "pages/modules/UnderwrittingModule";
import UserManagement from "pages/modules/UserManagementModule/UsermanagementModule";
import  ViewUserModuleRole from "pages/modules/UserManagementModule/ViewRole";
import ViewModuleUser from "pages/modules/UserManagementModule/ViewUser";

import { Layout } from "antd";
import ClientInvoices from "pages/Invoices/Invoices";
import ProfileSetup from "pages/onboarding/profile/ProfileSetup";
import KycSetup from "pages/onboarding/kyc/KycSetup";
// Valuation pages
import ValuationPanel from "pages/valuation/ValuationPanel";
import ValuationConfig from "pages/valuation/ValuationConfig";
import ValuationRequests from "pages/valuation/ValuationRequests";
import ViewValuer from "pages/valuation/ViewValuer";
import ViewValuationConfig from "pages/valuation/ViewValuationConfig";
import IntegrationPanel from "pages/integration/IntegrationPanel";
import DMVICIntegration from "pages/integration/dmvic/DMVICIntegration";

// New: client pages
import ClientManagement from "pages/clientmanagement/clientmanagement";
import ViewClient from "pages/clientmanagement/ViewClient";
import ServiceProviders from "pages/serviceProviders/ServiceProviders"
import ViewServiceProvider from "pages/serviceProviders/ViewServiceProvider";

import Claim from "pages/claims/Claim";

const Kyc = lazy(() => import("pages/kyc/KycContainer"));

const pages = [
  {
    exact: true,
    path: routes.login,
    component: Login,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.forgotPassword,
    component: ForgotPassword,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.verifyCode,
    component: VerifyCode,
    layout: PublicLayout,
  },
    {
    exact: true,
    path: routes.verifyOTP,
    component: VerifyOtp,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.resetPassword,
    component: ResetPassword,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.dashboard,
    component: Dashboard,
    layout: AuthLayout,
  },
  // Clients
  {
    exact: true,
    path: routes.clientManagement,
    component: ClientManagement,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewClient,
    component: ViewClient,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.serviceProviders,
    component: ServiceProviders,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.serviceProviderDetails,
    component: ViewServiceProvider,
    layout: AuthLayout,
  },
  // Valuation routes (added)
  {
    exact: true,
    path: routes.valuation,
    component: ValuationPanel,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.valuationConfig,
    component: ValuationConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.valuationConfigView,
    component: ViewValuationConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.valuationRequests,
    component: ValuationRequests,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.valuationView,
    component: ViewValuer,
    layout: AuthLayout,
  },
    {
        exact: true,
        path: routes.valuationproductconfig,
        component: ValuationProductConfig,
        layout: AuthLayout,
    },
    {
      exact: true,
      path: routes.integrationpanel,
      component: IntegrationPanel,
      layout: AuthLayout,
    },
    {
        exact: true,
        path: routes.productDocumentConfig,
        component: ProductDocumentConfig,
        layout: AuthLayout,
    },
   {
     exact: true,
     path: routes.integrationDMVIC,
     component: DMVICIntegration,
     layout: AuthLayout,
   },
  {
    exact: true,
    path: routes.signup,
    component: Signup,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.home,
    component: Home,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.credentials,
    component: Credentials,
    layout: PublicLayout,
  },

  {
    exact: true,
    path: routes.verify,
    component: VerifyEmail,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.kyc,
    component: Kyc,
    layout: PublicLayout,
  },
    {
    exact: true,
    path: routes.profilesetup,
    component: ProfileSetup,
    layout: PublicLayout,
  },
    {
    exact: true,
    path: routes.kycsetup,
    component: KycSetup,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.reset,
    component: Reset,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.resetPassword,
    component: VerifyReset,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.reset2,
    component: Reset2,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.underwriters,
    component: Underwriters,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.singleunderwriter,
    component: Underwriter,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotation,
    component: ViewQuotation,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotation1,
    component: ViewQuotation1,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.assetDetails,
    component: AssetDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.assetDetails1,
    component: AssetDetails1,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.quotations,
    component: Quotations,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.clientQuotations,
    component: ClientQuotations,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.quotations1,
    component: Quotations1,
    layout: AuthLayout,
  },


  // {
  //   exact: true,
  //   path: routes.viewClaim,
  //   component: ViewClaim,
  //   layout: AuthLayout,
  // },
  {
    exact: true,
    path: routes.viewClaimsPending,
    component: ViewClaimPendingContainer,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewRenewal,
    component: ViewRenewal,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.renewals,
    component: Renewals,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotationRequest,
    component: ViewRequests,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotationRequest1,
    component: ViewRequests1,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotationRequest,
    component: ViewRequests,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.quotationRequests,
    component: QuotationRequests,
    layout: AuthLayout,
  },{
  exact: true,
  path: routes.singleClientQuotation,
  component: SingleClientQuotation,
  layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.requests,
    component: Requests,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewPolicy,
    component: PolicyDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.portfolio, 
    component: Portfolio,
    layout: AuthLayout,
  },
   {
    exact: true,
    path: routes.singlepolicy, 
    component: SinglePolicy,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.policies,
    component: Policies,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.claims,
    component: Claims,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.claimsPending,
    component: ClaimsPending,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.viewClaim,
    component: Claim,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.policies,
    component: Policies,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewReportConfig,
    component: ViewReports,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewReportGroup,
    component: View_Report_Group,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewUsers,
    component: View_Users,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.reportConfig,
    component: Reports_Config,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgUsers,
    component: Users,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgViewUserGroup,
    component: View_User_Group,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgRoleView,
    component: ViewRole,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgRoles,
    component: Roles,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgViewDepartment,
    component: View_Department,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgDepartments,
    component: Departments,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.usmgViewUser,
    component: ViewUser,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.usmgUserGroup,
    component: UserGroups,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgViewChat,
    component: View_Chat_User,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgChat,
    component: ChatUsers,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgViewSecurity,
    component: View_Security_Context,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgSecurity,
    component: SecurityContext,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.wallet,
    component: Wallet,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewWallet,
    component: View_Wallet,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewCommission, 
    component: View_Commission, 
    layout: AuthLayout,
  },
  // {
  //   exact: true,
  //   path: routes.viewCommissionEntries, 
  //   component: CommissionEntries,  
  // },
  {
    exact: true,
    path: routes.viewLeads,
    component: LeadDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.leads,
    component: Leads,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.commissions,
    component: Commissions,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.profession,
    component: Profession,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.profile,
    component: Profile,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.appointments,
    component: Appointments,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgUsers,
    component: Users,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.tnc,
    component: TnC,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.tnc,
    component: TnC,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ptnc,
    component: Ptnc,
    layout: PublicLayout,
  },
  {
    exact: true,
    path: routes.settlementConfig,
    component: SettlementConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.tenders,
    component: Tenders,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.channels,
    component: Channels,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.settlement,
    component: Settlement,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.settlements,
    component: Settlements,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.settlements_configs,
    component: SettlementConfigs,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.settlements_config,
    component: SettlementConfigDetails,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.settlements_requests,
    component: settlementRequests,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.settlements_request,
    component: SettlementRequest,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.configDetails,
    component: ConfigDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.settlementDetails,
    component: SettlementDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.channelDetails,
    component: ChannelDetails,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.reviews,
    component: Reviews,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.chat,
    component: Chat,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.usmgChatGroups,
    component: ChatGroup,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.rmDetails,
    component: RMDetails,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.rm,
    component: RM,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.salesrep,
    component: SalesRep,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewSalesRep,
    component: SalesDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.taxDetails,
    component: TaxDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.tax,
    component: Tax,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.feeDetails,
    component: FeeDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.fees,
    component: Fees,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.domains,
    component: Domains,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.openLeads,
    component: OpenLeads,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.incentives,
    component: IncentivesContainer,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.incentiveDetails,
    component: IncentiveDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.schemes,
    component: Schemes,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.schemeDetails,
    component: SchemeDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.underwriterRates,
    component: UnderwriterDetails,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.groupSchemeManagement,
    component: GroupSchemeManagement,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.groupSchemeDetails,
    component: GroupSchemeDetails,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.products,
    component: Products,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.setup,
    component: Setup ,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.addbenefit,
    component: Benefits ,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewbenefit,
    component: Benefit ,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.adddmvic,
    component: Dmvic ,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.addproduct,
    component:  NewProduct ,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.editproduct,
    component:  EditProduct ,
    layout: AuthLayout,
  },

    {
    exact: true,
    path: routes.viewproduct,
    component:  ViewProduct ,
    layout: AuthLayout,
  },
  
  {
    exact: true,
    path: routes.addrate,
    component:  NewRate ,
    layout: AuthLayout,
  },
        {
    exact: true,
    path: routes.productlist,
    component:  ProductList ,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.viewproduct,
    component:  ViewProduct ,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.myaccount,
    component: Account,
    layout: AuthLayout,
  },
      {
    exact: true,
    path: routes.myunderwriters,
    component: Underwriter,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.policynoconfig,
    component: PolicyNumberConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.motorcertificateConfig,
    component: motorcertificateConfigPage,
    layout: AuthLayout,
  }, 
    {
    exact: true,
    path: routes.motorcertconfig,
    component: motorcertificateConfigPage,
    layout: AuthLayout,
  }, 
  {
    exact: true,
    path: routes.benefitsconfig,
    component: BenefitsSection,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.benefitconfig,
    component: BenefitsSection,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.excessconfig,
    component: ExcessLiabilityConfig,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.premiumpricing,
    component: PremiumConfigPage,
    layout: AuthLayout,
  },
  ,
    {
    exact: true,
    path: routes.paymentconfig,
    component: PaymentConfigPage,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.productpolicyconfig,
    component: PolicyConfigPage,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.accountingconfig,
    component: AccountingConfigPage,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.requirementsconfig,
    component: ProductRequirementsConfig,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.tnc,
    component: ProductTermsAndConditionsConfig,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.PaymentConfig,
    component: PaymentConfigPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.excessliabilityconfig,
    component: ExcessLiabilityConfig,
    layout: AuthLayout,
  },

  {
    exact: true,
    path: routes.Premiumpricingconfig,
    component: PremiumConfigPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.PaymentConfig,
    component: PaymentConfigPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.PolicyProductConfig,
    component: PolicyConfigPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.AccountingConfig,
    component: AccountingConfigPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ProductDetails,
    component: ProductDetailsPage,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.Inventory,
    component: Inventory,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.Reports,
    component: Reports,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes. invoices,
    component: Invoices,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes. commissionsreports,
    component: CommissionsReports,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.renewalsreports,
    component: RenewalsReports,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.singlerenewalpolicy,
    component: SinglePolicy,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.requirements,
    component: ProductRequirementsConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.terms,
    component: ProductTermsAndConditionsConfig,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.CommissionsAccount,
    component: CommissionsAccount,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.commissionDetailAccount,
    component: CommissionDetailAccount,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewQuotation,
    component: View_Quotation,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.DirectQuotation,
    component: DirectQuotation,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ViewDirectQuotation,
    component: ViewDirectQuotation,
    layout: AuthLayout,
  },
    {
    exact: true,
    path: routes.ClientHelpRequests,
    component: ClientHelpRequest,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ViewClientHelpRequest,
    component: ViewClientHelpRequest,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ClientInvoices,
    component: ClientInvoices,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.ViewClientInvoices,
    component: ViewInvoice,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.viewUnderwriter,
    component: ViewUnderwriter,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.AccountLanding,
    component: AccountManagement,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.AccountingCommission,
    component: AccountingCommissions,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.AccountingPolicies,
    component: AccountingPolicies,
    layout: AuthLayout,
  },
  {
    exact: true,
    path: routes.AccountingInvoices,
    component: AccountingInvoices,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.AccountingTaxes,
    component: AccountTaxes,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.AccountingWallet,
    component: AccountingWallet,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.ModulesView,
    component: Modules,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.UnderwrittingModule,
    component: UnderwritingServices,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.UserManagementModule,
    component: UserManagement,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.ViewUserRole,
    component: ViewUserModuleRole,
    layout: AuthLayout
  },
  {
    exact: true,
    path: routes.ViewUserDetails,
    component: ViewModuleUser,
    layout: AuthLayout
  },
    {
        exact: true,
        path: routes.myunderwriterview,
        component: View_Product_Underwriter,
        layout: AuthLayout,
    },
    {
        exact: true,
        path: routes.coverDetailsConfig,
        component: CoverageDetailsConfig,
        layout: AuthLayout,
    },
    {
        exact: true,
        path: routes.liabilityconfig,
        component: LiabilityConfig,
        layout: AuthLayout,
    }
];


function App() {
  const history = useHistory();

  return (
    <div className="App">
      <Suspense fallback={<Fallback />}>
        <Switch>
          {pages.map(
            ({ exact, path, component: Component, layout: Layout }, index) => (
              <Route
                key={index}
                exact={exact}
                path={path}
                render={(props) => (
                  <Layout history={history}>
                    <Component {...props} />
                  </Layout>
                )}
              />
            )
          )}
          <Route component={Error} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default NetworkDetector(App);
